export default "__VITE_ASSET__CQAxL3YP__"